import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { Skeleton, Stack } from '@mui/material';

const emsName = 'DPSV2FooterLeftPromotions';

export const Promotions = () => (
	<ContentRecommendation
		id={`footer-${emsName}`}
		properties={{ emsName }}
		loadingElement={
			<Stack gap={1}>
				<Skeleton variant="rectangular" width="200px" height="21px" />
				<Skeleton variant="rectangular" width="190px" height="21px" />
				<Skeleton variant="rectangular" width="180px" height="21px" />
				<Skeleton variant="rectangular" width="170px" height="21px" />
			</Stack>
		}
	/>
);
